import React from 'react';

const HideHeaderFnProvider = React.createContext<(shouldHideHeader: boolean) => void>(undefined);

export default HideHeaderFnProvider;
